import * as storeTypes from './store.type';

const initialState = {
  storeList: [],
  error: null,
  isLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // LIST
    case `${storeTypes.LIST_STORE_PENDING}`:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case `${storeTypes.LIST_STORE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        storeList: action.payload,
      };
    case `${storeTypes.LIST_STORE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
